import { gql } from '@apollo/client';
const GET_PRODUCTS_COSTS = gql `
  query GetProductsCosts($modelSpecificationId: ID!) {
    node(id: $modelSpecificationId) {
      ... on ModelSpecificationNode {
        id
        components {
          edges {
            node {
              id
              name
              productSnapshot {
                id
                name
                width
                componentSize
                composition
                zipperType
                grammage
                producerCode
                underSliderType
                upperSliderType
                yardage
                supplierShortName
                supplierFullName
                product {
                  id
                  status
                }
              }
              assignedProductVariantSnapshots {
                edges {
                  node {
                    id
                    color
                    size
                    price
                    currency {
                      id
                      isoCode
                    }
                    productVariant {
                      id
                      currentPrice {
                        id
                        price
                        currency {
                          id
                          isoCode
                        }
                      }
                    }
                    productVariant {
                      id
                      priceHistory {
                        edges {
                          node {
                            id
                            price
                            currency {
                              id
                              isoCode
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              productCategory {
                id
                type
                typeLabelPL
                typeLabelEN
                typeIcon
                hasName
                hasComposition
                hasComponentSize
                hasSupplier
                hasProductDescription
                hasWidth
                hasZipperType
                variantHasColor
                variantHasChainColor
                variantHasTapeColor
                variantHasSliderColor
                variantHasSize
                hasGrammage
                hasProducerCode
                hasUnderSliderType
                hasUpperSliderType
                hasYardage
                colorAutoCalculationMethod
              }
            }
          }
        }
        estimatedAdditionalCosts {
          edges {
            node {
              id
              name
              unit
              price
              currency {
                id
                isoCode
                name
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_PRODUCTS_COSTS;
